import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { useNavigate } from 'react-router-dom';
import { getApiUrl } from './config';

function SalesReport() {
    const [sales, setSales] = useState([]);
    const [viewInvoice, setViewInvoice] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchSales();
    }, []);

    const fetchSales = async () => {
        try {
            const res = await axios.get(`${getApiUrl()}/reports/sales`);
            setSales(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this invoice? Stock will be reversed.")) {
            try {
                await axios.delete(`${getApiUrl()}/sales/${id}`);
                fetchSales();
            } catch (err) {
                console.error(err);
            }
        }
    };

    const handleView = async (id) => {
        try {
            const res = await axios.get(`${getApiUrl()}/sales/${id}`);
            setViewInvoice(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Layout>
            <div className="container mt-4">
                <h2>Sales Report</h2>
                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Date</th>
                                <th>Customer</th>
                                <th>Items</th>
                                <th>Total</th>
                                <th>Paid</th>
                                <th>Invoice Bal</th>
                                <th>Net Bal</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sales.map(s => (
                                <tr key={s.invoice_id}>
                                    <td>{s.invoice_id}</td>
                                    <td>{new Date(s.date).toLocaleDateString()}</td>
                                    <td>{s.customer_name}</td>
                                    <td>{s.items_summary}</td>
                                    <td className="fw-bold">₹ {(s.total_amount || 0).toFixed(2)}</td>
                                    <td className="text-success">₹ {(s.paid_amount || 0).toFixed(2)}</td>
                                    <td className="text-muted">₹ {(s.invoice_balance || 0).toFixed(2)}</td>
                                    <td className="text-danger fw-bold">₹ {(s.cumulative_balance || 0).toFixed(2)}</td>
                                    <td>
                                        <button className="btn btn-info btn-sm me-1" onClick={() => handleView(s.invoice_id)}>View</button>
                                        <button className="btn btn-warning btn-sm me-1" onClick={() => navigate(`/sale?edit=${s.invoice_id}`)}>Edit</button>
                                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(s.invoice_id)}>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* View Modal */}
                {viewInvoice && (
                    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Invoice #{viewInvoice.id}</h5>
                                    <button type="button" className="btn-close" onClick={() => setViewInvoice(null)}></button>
                                </div>
                                <div className="modal-body">
                                    <p><strong>Date:</strong> {new Date(viewInvoice.date).toLocaleDateString()}</p>
                                    <p><strong>Customer ID:</strong> {viewInvoice.customer_id}</p>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Product</th>
                                                <th>Quantity</th>
                                                <th>Price</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {viewInvoice.items.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td>{item.product_name}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.price}</td>
                                                    <td>{item.total}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th colSpan="3" className="text-end">Grand Total</th>
                                                <th>₹ {(viewInvoice.total_amount || 0).toFixed(2)}</th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setViewInvoice(null)}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Layout>
    );
}

export default SalesReport;
